import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
    name:"user",
    initialState: {
        username:null,
        token:null,
        itoken:null,
        role:null,
    },
    reducers:{
        setUsername: (state, action) => {
            state.username = action.payload;
        },
        setToken: (state, action)=> {
            state.token = action.payload;
        },
        setItoken: (state, action)=> {
            state.itoken = action.payload;
        },
        setRole: (state, action)=> {
            state.role = action.payload;
        },
        resetUser: (state)=> {
            state.username = null;
            state.token = null;
            state.itoken = null;
            state.role = null;
        },
    }
});

export const { setUsername, setToken, setItoken, setRole, resetUser,} = userSlice.actions;

export default userSlice.reducer;